"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Card, CardContent } from "@/Components/website/ui/card";
import { Carousel, CarouselContent, CarouselItem } from "@/Components/website/ui/carousel";
import Image from "next/image";
import NextArrow from "@/Components/website/common/Icons/NextArrow";
import PreviousArrow from "@/Components/website/common/Icons/PreviousArrow";
import StarIcon from "@/Components/website/common/Icons/StarIcon";
// import { Inter } from "next/font/google";
import DoubleQuotesIcon from "@/Components/website/common/Icons/DoubleQuotesIcon";
// const inter = Inter({
//   subsets: ["latin"],
//   weight: ["400", "500", "600", "700", "800"],
// });
const Testimonials = () => {
  const $ = _c(19);
  const [carouselApi, setCarouselApi] = React.useState(null);
  let t0;
  if ($[0] !== carouselApi) {
    t0 = () => {
      carouselApi?.scrollPrev();
    };
    $[0] = carouselApi;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handlePrev = t0;
  let t1;
  if ($[2] !== carouselApi) {
    t1 = () => {
      carouselApi?.scrollNext();
    };
    $[2] = carouselApi;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleNext = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="hidden sm:block"><DoubleQuotesIcon /></div>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col  text-center md:text-left"><div className="text-primary-dark text-[24px] text-center md:text-[32px] lg:text-[40px] font-semibold">Providers Trust Us</div><div className="text-chocolateGrey text-[14px] md:text-[16px] font-medium">Hear the word of love providers have for our product</div></div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PreviousArrow />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handlePrev) {
    t5 = <button onClick={handlePrev} className="p-2 rounded-full ">{t4}</button>;
    $[7] = handlePrev;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <NextArrow />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== handleNext) {
    t7 = <button onClick={handleNext} className="p-2 rounded-full">{t6}</button>;
    $[10] = handleNext;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className="flex flex-col md:flex-row mx-auto justify-between items-center w-full  md:px-10 lg:px-20">{t2}{t3}<div className="flex pt-4 md:pt-0 gap-4 md:gap-6">{t5}{t7}</div></div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      align: "start",
      loop: true,
      slidesPerView: 1,
      breakpoints: {
        640: {
          slidesPerView: 1
        },
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 3
        }
      }
    };
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="testiminial-padding pl-20"><Carousel setApi={setCarouselApi} opts={t9} className="w-full pt-16 "><CarouselContent className=" flex-1 flex">{Array.from({
            length: 5
          }).map(_temp)}</CarouselContent></Carousel></div>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t8) {
    t11 = <><div className=" pt-20  w-full">{t8}{t10}</div></>;
    $[17] = t8;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};
export default Testimonials;
function _temp(_, index) {
  return <CarouselItem className=" lg:basis-[30%] md:basis-[50%] sm:basis-[80%] " key={index}><div className="p-1"><Card className="testimonial-card-bg"><CardContent className="flex   flex-col items-center justify-center p-6"><div><Image src="/Images/profilePic.png" priority={true} height={56} width={56} alt="profile Pic" /></div><div className="text-primary-dark pt-2 text-[20px] font-semibold">Emily P.</div><div className="text-primary-lightBlack text-[16px] font-medium">Works @ EC Clinic</div><div className="flex gap-1 pt-2 items-center"><StarIcon /><StarIcon /><StarIcon /><StarIcon /><StarIcon /></div><div className="text-secondary-darkGrey pt-3 text-[16px] font-normal text-center leading-tight">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua quis nostrud exercitation ullamcoLorem ipsum dolor sit amet, consectetur adipiscing elit do</div></CardContent></Card></div></CarouselItem>;
}